import { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import TypeBadge from '../components/TypeBadge';
import './MoveDetail.css';

function MoveDetail() {
  const { name } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [move, setMove] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_URL}/moves/${name}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch move details');
        }
        return response.json();
      })
      .then(data => {
        setMove(data);
        setLoading(false);
      })
      .catch(error => {
        setError(error.message);
        setLoading(false);
      });
  }, [name]);

  const handleBack = () => {
    if (location.state?.from === 'competitive') {
      navigate('/competitive', { state: { scrollPosition: location.state.scrollPosition } });
    } else {
      navigate(-1);
    }
  };

  if (loading) return <div className="loading">Loading move details...</div>;
  if (error) return <div className="error">Error: {error}</div>;
  if (!move) return <div className="error">Move not found</div>;

  return (
    <div className="move-detail">
      <button onClick={handleBack} className="back-link">← Back</button>
      <div className="move-header">
        <h2>{move.name}</h2>
        <TypeBadge type={move.type} />
      </div>
      <div className="move-content">
        <div className="move-info-section">
          <div className="move-stats-grid">
            <div className="stat-box">
              <h4>Power</h4>
              <span>{move.power || '-'}</span>
            </div>
            <div className="stat-box">
              <h4>Accuracy</h4>
              <span>{move.accuracy ? `${move.accuracy}%` : '-'}</span>
            </div>
            <div className="stat-box">
              <h4>PP</h4>
              <span>{move.pp || '-'}</span>
            </div>
            <div className="stat-box">
              <h4>Category</h4>
              <span>{move.category}</span>
            </div>
          </div>
          <div className="description-section">
            <h3>Description</h3>
            <p>{move.description}</p>
            <h4>Effect</h4>
            <p>{move.effect}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MoveDetail;